<template>
  <div class="office-wrapper">
    <div class="office-content" v-if="user">
      <h3 v-if="!user" class="mt-5">
        Авторизуйтесь, чтобы получить доступ к личному кабинету!
      </h3>

      <div class="user-info-wrapper" v-if="user">
        <div class="user-info">
          <div class="text-info">
            <div class="text-title">Личный кабинет</div>
            <div class="text-name">{{ user.name }}</div>
            <div class="text-email">{{ user.email }}</div>
          </div>

          <div class="codes-wrapper">
            <div class="text-code">{{ user.codes_count }}</div>
            <span class="hidden-mobile"
              >Зарегистрированных <br />
              кодов</span
            >
          </div>

          <span class="mobile text-code-mobile"
            >Зарегистрированных <br />
            кодов</span
          >

          <b-button
            class="promo-button button button-green mt-3"
            v-b-modal.password-modal
            variant="primary"
          >
            Изменить пароль
          </b-button>
        </div>

        <b-button
          class="promo-button button button-gold"
          v-b-modal.enter-code-modal
          variant="primary"
          onclick="ym(108239013,'reachGoal', 'cod_lk')"
        >
          Введите код
        </b-button>
      </div>

      <OfficeTable />
    </div>

    <!-- <div class="office-content borders mobile"
         v-if="user">
      <div class="">
        <OfficeTable />
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import OfficeTable from "@/components/OfficeTable.vue";
import { mapGetters, mapMutations } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Office",

  components: {
    OfficeTable,
  },

  mixins: [validationMixin],

  validations: {
    item: {
      oldPassword: {
        required,
      },
      password: {
        required,
      },
    },
  },

  data: () => ({
    form: false,
    item: {
      oldPassword: "",
      password: "",
    },
  }),

  mounted() {
    if (!localStorage.getItem("token-bockarev")) {
      window.location.href = "/";
    }

    setTimeout(() => {
      if (this.user.has_passport) {
        this.$bvModal.show("verification-modal")
      }
    }, 500)
  },

  computed: {
    ...mapGetters({
      user: "user",
    }),

    disabledBtn() {
      return !!(
        this.item.oldPassword.length < 1 || this.item.password.length < 1
      );
    },
  },

  methods: {
    ...mapMutations({
      saveUser: "saveUser",
      saveToken: "saveToken",
    }),

    openForm() {
      this.form = true;
    },

    openModal() {
      this.$bvModal.show("plug-modal");
    },

    resetForm() {
      this.$v.$reset();

      ((this.item.oldPassword = ""),
        (this.item.password = ""),
        (this.form = false));

      this.$bvModal.show("password-changed-modal");
    },

    hideForm() {
      this.$v.$reset();

      ((this.form = false),
        (this.item.oldPassword = ""),
        (this.item.password = ""));
    },

    validateState(item) {
      const { $dirty, $error } = item;
      return $dirty ? !$error : null;
    },

    logout() {
      axios
        .post(
          "auth/logout",
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "access-control-allow-origin": "*",
              Authorization: "Bearer " + localStorage.getItem("token-bockarev"),
            },
          },
        )
        .then((response) => {
          this.saveUser(null);
          this.saveToken(null);
          window.location.href = "/";

          localStorage.removeItem("token-bockarev");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.office-wrapper {
  font-family: $regular !important;
  display: flex;
  justify-content: center;
  background-image: url("@/assets/office-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  width: 100%;
  height: 100%;
  background-color: white;
  padding-top: 184px;
  min-height: calc(100vh - 336px);

  @media (max-width: 1500px) {
    background-position: top;
  }

  @media (max-width: 1200px) {
    flex-direction: column;
  }

  @media (max-width: 678px) {
    padding-top: 100px;
  }

  .borders {
    border-radius: 25px !important;
    margin-top: 30px;
    padding-top: 60px !important;
  }

  .office-content {
    max-width: 1200px;
    width: 100%;
    min-height: 600px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;

    @media (max-width: 1200px) {
      min-height: auto;
      border-radius: 0 0 25px 25px;
    }

    @media (max-width: 768px) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}

.user-info-wrapper {
  max-width: 600px;
  color: white;
  width: 100%;
}

.user-info {
  background-color: #00712f;
  border-radius: 230px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 80px;
  height: 195px;
  position: relative;
  margin-bottom: 30px;

  @media (max-width: 678px) {
    flex-direction: column;
    height: auto;
    padding-left: 0;
    border-radius: 62px;
    padding-top: 38px;
    padding-bottom: 25px;
    margin-bottom: 50px;
  }
}

.text-info {
  color: white !important;

  @media (max-width: 678px) {
    text-align: center;
  }
}

.text-title {
  font-size: 24px;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 18px;

  @media (max-width: 678px) {
    text-align: center;
  }
}

.text-name {
  text-align: left;
  margin-bottom: 10px;

  @media (max-width: 678px) {
    text-align: center;
    margin-bottom: 2px;
  }
}

.text-email {
  text-align: left;

  @media (max-width: 678px) {
    text-align: center;
  }
}

.codes-wrapper {
  background-color: white;
  border-radius: 50%;
  margin-right: 5px;
  height: 93%;
  min-width: 172px;
  color: #004a0b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 106%;
  padding: 16px;

  @media (max-width: 678px) {
    min-width: 52px;
    height: 52px;
    margin-top: 20px;
    padding: 0;
  }
}

.text-code {
  font-size: 66px;
  font-weight: 600;
  line-height: 120%;
  margin-top: -16px;

  @media (max-width: 678px) {
    font-size: 26px;
    margin-top: 0;
  }
}

.text-code-mobile {
  color: white;
  line-height: 106%;
  margin-top: 10px;
  font-size: 13px;
}

.button-green {
  border: 2px solid #BD7A30 !important;
  text-transform: uppercase;
  position: absolute;
  max-width: 260px;
  font-size: 16px !important;
  height: 47px !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 110%);

  @media(max-width: 678px) {
    transform: translate(-50%, 240%);
  }
}

.button {
  width: 100%;
  height: 56px;
  border-radius: 14px !important;
  background-color: #00712F;
  border-radius: 60px !important;

  &:hover {
    background-color: #004A0B !important;
    opacity: .9;
  }

  &:focus {
    background-color: #004A0B !important;
  }

  &:active {
    background-color: #004A0B !important;
  }
}

.desktop {
  @media (max-width: 1200px) {
    display: none;
  }
}

.mobile {
  display: none;

  @media (max-width: 678px) {
    display: block;
  }
}

.hidden-mobile {
  @media (max-width: 678px) {
    display: none;
  }
}

.mr-5 {
  @media (max-width: 1200px) {
    margin-right: 0px !important;
  }
}

.button-gold {
  border: 1px transparent;
  background-image: none !important;
  background: linear-gradient(90deg, #BD7A30 0%, #F2BC81 100%) !important;
  transition: .4s all;
  border-radius: 60px !important;

  &:hover {
    background-image: none !important;
    background: #004A0B !important;
    border: 1px solid #BD7A30 !important;
    transition: .4s all;
  }
}
</style>
